import { last } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import ConnectIpsServices from "../../../OrderingSystem/PublicOrdering/services/connectIpsServices";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(true);

  console.log("🚀 ~ PaymentSuccess ~ error:", error);
  console.log("🚀 ~ PaymentSuccess ~ paymentStatus:", paymentStatus);
  // const { orgcode } = useParams();

  const orgcode = localStorage.getItem("orgcode");

  // Get order details from localStorage
  const lastOrder = JSON.parse(localStorage.getItem("orderResponse") || "{}");
  console.log("🚀 ~ PaymentSuccess ~ lastOrder:", lastOrder);
  const orderRef = lastOrder?.orderRefrenceId;

  useEffect(() => {
    console.log("useEffect triggered, orderRef:", orderRef, "orgcode:", orgcode);
    if (!orderRef || !orgcode) {
      console.log("Skipping API call: orderRef or orgcode is missing");
      return;
    }

    const fetchPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await ConnectIpsServices.validateConnectIpsPayment(orderRef, orgcode);
        setPaymentStatus(response.data);
      } catch (err) {
        setError(err?.response?.data || err);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentStatus();
  }, [orderRef, orgcode]);

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        maxWidth: "1600px",
        margin: "0 auto",
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <Row>
        <Col md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
          <Card
            style={{
              borderRadius: "15px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
              border: "none",
            }}
          >
            <CardBody style={{ padding: "40px", textAlign: "center" }}>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#d4edda",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                }}
              >
                <i
                  className="ri-checkbox-circle-fill"
                  style={{ fontSize: "48px", color: "#28a745" }}
                ></i>
              </div>

              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  color: "#333",
                }}
              >
                Payment Successful!
              </h2>

              <p
                style={{
                  fontSize: "16px",
                  color: "#666",
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}
              >
                Thank you for your payment. Your order has been placed
                successfully and is being processed.
              </p>

              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "10px",
                  padding: "20px",
                  marginBottom: "30px",
                  textAlign: "left",
                }}
              >
                {/* <div style={{  */}
                {/*   display: "flex",  */}
                {/*   justifyContent: "space-between",  */}
                {/*   marginBottom: "10px"  */}
                {/* }}> */}
                {/*   <span style={{ color: "#666" }}>Order ID:</span> */}
                {/*   <span style={{ fontWeight: "600", color: "#333" }}> */}
                {/*     {lastOrder.orderId || "N/A"} */}
                {/*   </span> */}
                {/* </div> */}
                {/* <div style={{  */}
                {/*   display: "flex",  */}
                {/*   justifyContent: "space-between", */}
                {/*   marginBottom: "10px" */}
                {/* }}> */}
                {/*   <span style={{ color: "#666" }}>Payment Method:</span> */}
                {/*   <span style={{ fontWeight: "600", color: "#333" }}> */}
                {/*     {lastOrder.paymentType || "N/A"} */}
                {/*   </span> */}
                {/* </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#666" }}>Status:</span>
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#28a745",
                      backgroundColor: "#d4edda",
                      padding: "2px 12px",
                      borderRadius: "12px",
                      fontSize: "14px",
                    }}
                  >
                    Received
                  </span>
                </div>
              </div>

              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                {/* <Button
                  color="success"
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500"
                  }}
                  onClick={() => navigate(`/${orgcode}/order-summary`)}
                >
                  View Order
                </Button> */}
                <Button
                  color="primary"
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={() => navigate(`/${orgcode}`)}
                >
                  Back to Menu
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccess;
